// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as AlertTriangleDefault } from '../../../assets/icons/default/alerts_feedback/alert-triangle.svg?react';
import { ReactComponent as AlertTriangleSolid } from '../../../assets/icons/solid/alerts_feedback/ALERT-TRIANGLE.svg?react';
import { createIcons } from '../../Icon';
const AlertTriangleIcon = /* @__PURE__ */ createIcons('AlertTriangle', {
    default: AlertTriangleDefault,
    solid: AlertTriangleSolid
});
AlertTriangleIcon.supportedTypes = ['default', 'solid'];
AlertTriangleIcon.category = 'alerts_feedback';
export default AlertTriangleIcon;
